// extracted by mini-css-extract-plugin
export default {"pyramidText":"PartnershipPage_pyramidText__idE0n","title":"PartnershipPage_title__f4eB+"};